import { Box, Flex, Stack, StackProps } from '@chakra-ui/react'
import { Body1 } from 'components/typography'
import { MEDIA_LINKS } from 'constants/mediaLinks'
import { useGeoPreview } from 'modules/landings/geo/adsSafe'
import { PressLogos } from 'modules/landings/geo/PreviewSections'
import { FC } from 'react'

/** On the GEO validation copies: one logo per article, each linked to it, and "Ver todas as matérias" (Morgan, 24/10/2026). */
export const PressSection: FC<StackProps> = (props) => {
  const isGeoPreview = useGeoPreview()
  return (
    <Stack {...props}>
      <Body1 color="magicmint" pb={1} mb={{ base: 2, lg: 4 }} borderBottom="2px solid #153F48">
        Imprensa
      </Body1>
      {isGeoPreview ? (
        <PressLogos tone="mint" />
      ) : (
        <Flex
          wrap="wrap"
          gap={{ base: '1rem', lg: '2rem' }}
          align="center"
          justifyContent={{ base: 'space-between', lg: 'normal' }}
        >
          {MEDIA_LINKS.map(({ icon, href }) => (
            <Box key={href}>
              <a href={href} target="_blank" rel="noopener noreferrer" key={href}>
                <Box as={icon} fill="magicmint" />
              </a>
            </Box>
          ))}
        </Flex>
      )}
    </Stack>
  )
}
